import { render, staticRenderFns } from "./ruta-culturetas.vue?vue&type=template&id=264d4be1&"
import script from "./ruta-culturetas.vue?vue&type=script&lang=js&"
export * from "./ruta-culturetas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports